import React, { useContext, useEffect, useRef, useState } from 'react';
import FadeIn from 'react-fade-in';
import { Observer } from 'mobx-react-lite';
import momentLocalizer from 'react-widgets-moment';
import MaskedInput from 'react-text-mask'
import { Combobox, DropdownList } from 'react-widgets'
import { GlobalHotKeys } from 'react-hotkeys';
import { toast } from 'react-toastify';
import moment from 'moment';

import BodyEnd from '../../_shared/BodyEnd';
import ConfirmModal from '../../_shared/ConfirmModal';
import RichTextEditor from '../../_shared/RichTextEditor';
import { quickDrawerFocus, renderQuickDrawerLoading } from '../../_shared/QuickDrawer';
import QuickDrawerHeader from '../../_shared/QuickDrawerHeader';

import ProductUpdateStore from '../../../../stores/ProductUpdateStore';
import QuickDrawerStore from '../../../../stores/QuickDrawerStore';

import * as ErrorMessages from '../../../../constants/errorMessages';
import * as MaskKeys from '../../../../constants/maskKeys';
import * as AccessType from '../../../../constants/accessTypes';
import * as fn from '../../../../utilities/_functions';
import * as ph from '../../../../utilities/productHelper';
import * as ah from '../../../../utilities/accessHelper';
import * as oh from '../../../../utilities/operationHelper';

import api from '../../../../api';

import './UpdateProduct.scss';

moment.locale('en');
momentLocalizer();


function UpdateProduct(props) {
    const isMounted = useRef(true);
    const validateRef = useRef(null);
    const cancelProductBrandUpdate = useRef(null);
    const product = useContext(ProductUpdateStore);
    const quickDrawer = useContext(QuickDrawerStore);
    const [confirmTypeChange, setConfirmTypeChange] = useState(false);
    const [confirmNewBrandMapping, setConfirmNewBrandMapping] = useState(false);

    useEffect(() => {
        quickDrawerFocus(props.drawer);
        return () => {
            isMounted.current = false;

            if (cancelProductBrandUpdate.current && fn.isFunction(cancelProductBrandUpdate.current)) {
                cancelProductBrandUpdate.current();
                cancelProductBrandUpdate.current = null;
            }
        }
    }, []) // eslint-disable-line

    const handleCancel = () => {
        if (fn.isFunction(props.onCancel)) {
            if (product.hasUnsavedChanges) {
                if (window.confirm(ErrorMessages.DISCARD_CHANGES)) {
                    props.onCancel();
                }
            } else {
                props.onCancel();
            }
        }
    }

    const handleTypeChange = ({ id }) => {
        product.updateType(id);
    }

    const handleBrandChange = (data) => {
        product.data.brandId = data.id;
        product.data.supplierId = data.supplierId;
        product.hasUnsavedChanges = true;
    }

    const handleNameChange = event => {
        const previousName = product.data.name;
        const value = event.target.value;

        product.data.name = value;

        if (product.data.descriptor === previousName) {
            product.data.descriptor = value;
        }

        product.hasUnsavedChanges = true;
    }

    const handleDescriptorChange = event => {
        product.data.descriptor = event.target.value;
        product.hasUnsavedChanges = true;
    }

    // const handleSkuNumberChange = event => {
    //     product.data.skuNumber = event.target.value;
    //     product.hasUnsavedChanges = true;
    // }

    // const handleIsStockedChange = event => {
    //     const isStocked = !product.data.isStocked;

    //     product.data.isStocked = isStocked;
    //     product.data.isTracked = isStocked;
    //     product.hasUnsavedChanges = true;
    // }

    const handleIsTrackedChange = event => {
        const isTracked = !product.data.isTracked;
        product.data.isTracked = isTracked;
        product.data.quantity = product.data.quantity ? product.data.quantity : 1;
        product.hasUnsavedChanges = true;
    }

    const handleDefaultApplyTaxChange = event => {
        const defaultApplyTax = !product.data.defaultApplyTax;
        product.data.defaultApplyTax = defaultApplyTax;
        product.hasUnsavedChanges = true;
    }

    const handleReferenceNumberChange = event => {
        product.referenceNumber = event.target.value;
        product.hasUnsavedChanges = true;
    }

    const handleNoteChange = (content, delta, source, editor) => {
        const note = editor.getText().replace(/(\r\n|\n|\r)/g, ' ').trim();
        const noteHtml = (content === '<p><br></p>') ? null : content;

        product.note = note;
        product.noteHtml = noteHtml;
        product.hasUnsavedChanges = true;
    }

    // const handleSerialNumberChange = (event, index) => {
    //     product.data.serialNumbers[index] = event.target.value;
    //     product.hasUnsavedChanges = true;
    // }

    const handleOptionTextChange = (event, key) => {
        const text = event.target.value;
        handleOptionValueChange(key, text);
        product.hasUnsavedChanges = true;
    }

    const handleOptionValueChange = (key, option) => {
        const index = product.data.data.findIndex(d => d.key === key);
        const value = option.value ? option.value : option;

        if (index >= 0) {
            if (value) {
                product.data.data[index].value = value;
            } else {
                product.data.data.remove(product.data.data[index]);
            }
        } else {
            if (value) {
                const option = product.selectedType.data.filter(d => d.key === key)[0];

                option.value = value;
                product.data.data.push(option);
            }
        }
        product.hasUnsavedChanges = true;
    }

    const handleQuantityChange = event => {
        const quantity = parseInt(event.target.value, 10);
        product.data.quantity = quantity;
        product.hasUnsavedChanges = true;
    }

    const handleQuantityBlur = event => {
        if (product.data.serialNumbers.length > product.data.quantity) {
            let count = 0;
            const diff = product.data.serialNumbers.length - product.data.quantity;

            do {
                product.data.serialNumbers.remove(product.data.serialNumbers[product.data.serialNumbers.length - 1]);
                count++;
            } while (diff !== count)
        }
        product.hasUnsavedChanges = true;
    }

    const handleCostChange = event => {
        product.data.cost = event.target.value;
        product.hasUnsavedChanges = true;
    }

    const handlePriceChange = event => {
        product.data.price = event.target.value;
        product.hasUnsavedChanges = true;
    }

    // const handleSerialNumberAdd = (event, index) => {
    //     product.data.serialNumbers.splice((index + 1), 0, '');
    //     product.hasUnsavedChanges = true;
    // }

    // const handleSerialNumberRemove = (event, index) => {
    //     product.data.serialNumbers.remove(product.data.serialNumbers[index]);
    //     product.hasUnsavedChanges = true;
    // }

    const handleSubmit = event => {
        event.preventDefault();

        if (fn.validateForm(validateRef.current)) {
            if (product.originalData.typeId !== product.data.typeId) {
                setConfirmTypeChange(true);
            } else {
                handleNewBrandMapping(event);
            }
        }
    }

    const handleNewBrandMapping = (event) => {
        return new Promise((resolve) => {
            if (product.newBrandMapping) {
                setConfirmTypeChange(false);
                setConfirmNewBrandMapping(true);
                resolve();
            }
            else {
                handleSaveProduct(event).then(() => { resolve(); })
            }
        })
    }

    const handleSaveProduct = (event) => {
        return new Promise((resolve) => {
            product.save(true)
                .then(data => {
                    if (isMounted.current) {
                        if (props.onSuccess && fn.isFunction(props.onSuccess)) {
                            props.onSuccess(event, data);
                        }

                        resolve();
                    }
                })
        })
    }

    const handleConfirmTypeChange = event => {
        handleNewBrandMapping(event);
    }

    const handleCancelTypeChange = event => {
        setConfirmTypeChange(false);
        setConfirmNewBrandMapping(false);
    }

    const handleConfirmNewBrandMapping = event => {
        const { newBrandMapping } = product;

        if (newBrandMapping) {
            api.ProductBrands.search({
                parameters: [{
                    field: 'Name',
                    value: newBrandMapping.name,
                }, {
                    field: 'DeactivatedDateUtc',
                    value: null,
                }],
                includeTotalCount: false,
            })
                .then(({ data }) => {
                    if (isMounted.current) {
                        const typeIds = data && data.result ? data.result[0].typeIds : [];

                        if (!typeIds.some(t => t === product.selectedType.id)) {
                            typeIds.push(product.selectedType.id)
                        }

                        api.ProductBrands.update(newBrandMapping.id, {
                            name: newBrandMapping.name,
                            typeIds: typeIds,
                            supplierId: newBrandMapping.supplierId,
                        }, (c) => { cancelProductBrandUpdate.current = c })
                            .then(() => {
                                if (isMounted.current) {
                                    handleSaveProduct(event);
                                }
                            })
                            .catch(() => {
                                toast.error(() => ErrorMessages.GENERIC_ERROR_HTML, { position: 'top-center', style: { width: '380px' } });
                            })
                    }
                })
                .catch(() => {
                    toast.error(() => ErrorMessages.GENERIC_ERROR_HTML, { position: 'top-center', style: { width: '380px' } });
                })
        } else {
            handleSaveProduct(event);
        }
    }

    const handleCancelNewBrandMapping = event => {
        setConfirmNewBrandMapping(false);
        setConfirmTypeChange(false);
    }

    const getOptionValue = key => {
        if (product.data.data && product.data.data.some(d => d.key === key)) {
            return product.data.data.filter(d => d.key === key)[0].value;
        }
        return '';
    }

    const getIsDisabled = () => {
        return !product.selectedType.brands || product.selectedType.brands.length === 0;
    }

    return <>
        <Observer>{() =>
            <>
                {
                    (props.drawer === quickDrawer.drawerOpened) && !confirmTypeChange && !confirmNewBrandMapping ?
                        <GlobalHotKeys
                            keyMap={{
                                close: ['esc'],
                            }}
                            handlers={{
                                close: event => {
                                    handleCancel(event)
                                },
                            }}
                            allowChanges={true}
                        /> : null
                }
            </>
        }</Observer>
        <form ref={validateRef} onSubmit={handleSubmit}>
            <fieldset disabled={product.isSaving}>
                <div className='quick-drawer'>
                    <QuickDrawerHeader
                        drawer={props.drawer}
                        icon={oh.getIcon('product', 'update')}
                        action='Update'
                        category='Product'
                        className='products'
                        onCancel={handleCancel}
                    />
                    <div className='quick-drawer-body'>
                        <Observer>{() =>
                            product.isReady ?
                                <FadeIn>
                                    <div className='update-product body-content'>
                                        <section className='type'>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-0 validate validate-required'>
                                                        <label className='required'><small>Category</small></label>
                                                        <DropdownList
                                                            data={product.types}
                                                            valueField='id'
                                                            value={product.data.typeId}
                                                            itemComponent={({ item }) => (
                                                                item ? <>{item.name}</> : <></>
                                                            )}
                                                            valueComponent={({ item }) => (
                                                                item ? <>{item.name}</> : <></>
                                                            )}
                                                            onChange={handleTypeChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                        <Observer>{() =>
                                            <section className='brand'>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        {
                                                            product.isReady ?
                                                                <div className='form-group mb-0 validate validate-required'>
                                                                    <label className='required'><small>Brand</small></label>
                                                                    <DropdownList
                                                                        data={product.selectedType.brands}
                                                                        valueField='id'
                                                                        value={product.data.brandId}
                                                                        itemComponent={({ item }) => (
                                                                            item ? <>
                                                                                {item.name}
                                                                                {
                                                                                    item.supplier ?
                                                                                        <>
                                                                                            <br /><small>{item.supplier.name}</small>
                                                                                        </> : null
                                                                                }
                                                                                {
                                                                                    product.newBrandMapping && product.newBrandMapping.id === item.id ?
                                                                                        <span className='badge badge-new mb-0 float-right'>New</span> : null
                                                                                }
                                                                            </> : <></>
                                                                        )}
                                                                        valueComponent={({ item }) => (
                                                                            item ? <>
                                                                                {item.name}
                                                                                {
                                                                                    item.supplier ?
                                                                                        <>
                                                                                            <small className='text-gray-700 ml-1'>({item.supplier.name})</small>
                                                                                        </> : null
                                                                                }
                                                                                {
                                                                                    product.newBrandMapping && product.newBrandMapping.id === item.id ?
                                                                                        <span className='badge badge-new mb-0 float-right'>New</span> : null
                                                                                }
                                                                            </> : <></>
                                                                        )}
                                                                        onChange={handleBrandChange}
                                                                    />
                                                                </div> : null
                                                        }
                                                    </div>
                                                </div>
                                            </section>
                                        }</Observer>
                                        <section>
                                            <div className='row'>
                                                {
                                                    product.data.isStocked ?
                                                        <>
                                                            <div className='col-6'>
                                                                <Observer>{() =>
                                                                    <div className='form-group mb-0'>
                                                                        <label><small>{ph.getInventoryTypeDescription(product.selectedType.inventory)}</small></label>
                                                                        <div className='custom-control custom-checkbox'>
                                                                            <input
                                                                                id='product-is-tracked'
                                                                                type='checkbox'
                                                                                name='product-is-tracked'
                                                                                className='custom-control-input'
                                                                                checked={product.data.isTracked ? product.data.isTracked : false}
                                                                                onChange={handleIsTrackedChange}
                                                                            />
                                                                            <label
                                                                                htmlFor='product-is-tracked'
                                                                                className='custom-control-label'
                                                                            >
                                                                                Track stock level
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                }</Observer>
                                                            </div>
                                                            <div className='col-6'>
                                                                <Observer>{() =>
                                                                    <div className='form-group mb-0'>
                                                                        <label><small>&nbsp;</small></label>
                                                                        <div className='custom-control custom-checkbox'>
                                                                            <input
                                                                                id='product-apply-tax'
                                                                                type='checkbox'
                                                                                name='product-apply-tax'
                                                                                className='custom-control-input'
                                                                                checked={product.data.defaultApplyTax === true ? product.data.defaultApplyTax : false}
                                                                                onChange={handleDefaultApplyTaxChange}
                                                                            />
                                                                            <label
                                                                                htmlFor='product-apply-tax'
                                                                                className='custom-control-label'
                                                                            >
                                                                                Apply Tax By Default
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                }</Observer>
                                                            </div>
                                                        </> :
                                                        <div className='col-6'>
                                                            <Observer>{() =>
                                                                <div className='form-group mb-0'>
                                                                    <label><small>{ph.getInventoryTypeDescription(product.selectedType.inventory)}</small></label>
                                                                    <div className='custom-control custom-checkbox'>
                                                                        <input
                                                                            id='product-apply-tax'
                                                                            type='checkbox'
                                                                            name='product-apply-tax'
                                                                            className='custom-control-input'
                                                                            checked={product.data.defaultApplyTax === true ? product.data.defaultApplyTax : false}
                                                                            onChange={handleDefaultApplyTaxChange}
                                                                        />
                                                                        <label
                                                                            htmlFor='product-apply-tax'
                                                                            className='custom-control-label'
                                                                        >
                                                                            Apply Tax By Default
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            }</Observer>
                                                        </div>
                                                }
                                            </div>
                                        </section>
                                        {
                                            <Observer>{() =>
                                                <section>
                                                    <div className='row'>
                                                        <div className={product.data.isStocked && product.data.isTracked ? 'col-4' : 'd-none'}>
                                                            <div className='form-group mb-0 validate validate-required'>
                                                                <label
                                                                    className='required'
                                                                    htmlFor='new-product-quantity'
                                                                >
                                                                    <small className={(!product.data.quantity || product.data.quantity === 0 ? ' text-danger' : '')}>
                                                                        Quantity
                                                                    </small>
                                                                </label>
                                                                <input
                                                                    id='new-product-quantity'
                                                                    type='number'
                                                                    className={'form-control' + (!product.data.quantity || product.data.quantity === 0 ? ' text-danger' : '')}
                                                                    min={0}
                                                                    step={1}
                                                                    disabled={getIsDisabled() || !product.data.isStocked || !product.data.isTracked}
                                                                    value={(product.data && product.data.quantity ? product.data.quantity : 0)}
                                                                    onChange={handleQuantityChange}
                                                                    onBlur={handleQuantityBlur}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className={product.data.isStocked && product.data.isTracked ? 'col-4' : 'col-6'}>
                                                            <div className='form-group mb-0 validate validate-required'>
                                                                <label className='required' htmlFor='new-product-price'><small>Price</small></label>
                                                                <MaskedInput
                                                                    id='new-product-price'
                                                                    type='text'
                                                                    className='form-control'
                                                                    spellCheck={false}
                                                                    mask={MaskKeys.CURRENCY_MASK}
                                                                    maxLength='25'
                                                                    autoComplete='off'
                                                                    disabled={getIsDisabled()}
                                                                    value={product.data && product.data.price ? product.data.price : ''}
                                                                    onChange={handlePriceChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        {
                                                            ah.check(AccessType.UPDATE_PRODUCT) ?
                                                                <div className={product.data.isStocked && product.data.isTracked ? 'col-4' : 'col-6'}>
                                                                    <div className='form-group mb-0'>
                                                                        <label htmlFor='new-product-cost'><small>Cost</small></label>
                                                                        <MaskedInput
                                                                            id='new-product-cost'
                                                                            type='text'
                                                                            className='form-control placeholder placeholder-sm'
                                                                            spellCheck={false}
                                                                            mask={MaskKeys.CURRENCY_MASK}
                                                                            maxLength='25'
                                                                            autoComplete='off'
                                                                            disabled={getIsDisabled()}
                                                                            value={product.data && product.data.cost ? product.data.cost : ''}
                                                                            onChange={handleCostChange}
                                                                        />
                                                                    </div>
                                                                </div> : null
                                                        }
                                                    </div>
                                                </section>
                                            }</Observer>
                                        }
                                        {
                                            <Observer>{() =>
                                                <section className={product.data.isStocked && product.data.isTracked && product.originalData.quantity !== product.data.quantity ? '' : 'd-none'}>
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            <div className={'form-group'}>
                                                                <label htmlFor='new-product-reference'><small>Quantity Adjustment Reference No.</small></label>
                                                                <input
                                                                    id='new-product-reference'
                                                                    type='text'
                                                                    className='form-control'
                                                                    value={product.referenceNumber ? product.referenceNumber : ''}
                                                                    onChange={handleReferenceNumberChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            }</Observer>
                                        }
                                        {
                                            <Observer>{() =>
                                                <section className={product.data.isStocked && product.data.isTracked && product.originalData.quantity !== product.data.quantity ? '' : 'd-none'}>
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            <div className={'form-group'}>
                                                                <label htmlFor='new-product-note'><small>Quantity Adjustment Note</small></label>
                                                                <RichTextEditor
                                                                    mode='basic'
                                                                    value={product.noteHtml}
                                                                    disableTab={true}
                                                                    onChange={handleNoteChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            }</Observer>
                                        }
                                        <Observer>{() =>
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        {
                                                            product.isReady ?
                                                                <div className='form-group mb-0 validate validate-required'>
                                                                    <label className='required'><small>Name</small></label>
                                                                    <input
                                                                        type='text'
                                                                        className='form-control'
                                                                        spellCheck={false}
                                                                        maxLength='150'
                                                                        autoComplete='off'
                                                                        disabled={getIsDisabled()}
                                                                        value={product.data && product.data.name ? product.data.name : ''}
                                                                        onChange={handleNameChange}
                                                                    />
                                                                </div> : null
                                                        }
                                                    </div>
                                                </div>
                                            </section>
                                        }</Observer>
                                        <Observer>{() =>
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        {
                                                            product.isReady ?
                                                                <div className='form-group mb-0 validate validate-required'>
                                                                    <label className='required'><small>Invoice Descriptor</small></label>
                                                                    <input
                                                                        type='text'
                                                                        className='form-control'
                                                                        spellCheck={false}
                                                                        maxLength='150'
                                                                        autoComplete='off'
                                                                        disabled={getIsDisabled()}
                                                                        value={product.data && product.data.descriptor ? product.data.descriptor : ''}
                                                                        onChange={handleDescriptorChange}
                                                                    />
                                                                </div> : null
                                                        }
                                                    </div>
                                                </div>
                                            </section>
                                        }</Observer>
                                        {/* <Observer>{() =>
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group mb-0'>
                                                            <label><small>Sku Number</small></label>
                                                            <input
                                                                type='text'
                                                                className='form-control'
                                                                spellCheck={false}
                                                                maxLength='150'
                                                                autoComplete='off'
                                                                disabled={getIsDisabled()}
                                                                value={product.data.skuNumber ? product.data.skuNumber : ''}
                                                                onChange={handleSkuNumberChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        }</Observer> */}
                                        {/* <Observer>{() => (
                                            product.isReady && product.data && product.data.isStocked && product.data.isTracked && product.data.quantity > 0 ? <>
                                                <section className='serial-numbers'>
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            <div className='form-group'>
                                                                <label><small>Serial Number{product.data.serialNumbers.length > 1 ? 's' : ''}</small></label>
                                                                {
                                                                    product.data.serialNumbers.map((n, ni) => {
                                                                        return <div
                                                                            key={`serial_number_${ni}`}
                                                                            className={'serial-number-input' + (product.data.quantity < (ni + 1) ? ' d-none' : '') + (product.data.quantity === (ni + 1) ? ' last-input' : '') + (ni === 0 ? '' : ' mt-2')}
                                                                        >
                                                                            <input
                                                                                type='text'
                                                                                className='form-control placeholder placeholder-sm mb-2'
                                                                                spellCheck={false}
                                                                                maxLength='100'
                                                                                autoComplete='off'
                                                                                placeholder={`${(product.data.serialNumbers.length === 1 ? '' : `Serial Number #${ni + 1}`)}`}
                                                                                value={n ? n : ''}
                                                                                onChange={e => { handleSerialNumberChange(e, ni) }}
                                                                            />
                                                                            <div className='button-group'>
                                                                                <button
                                                                                    type='button'
                                                                                    className='btn btn-link btn-icon btn-sm'
                                                                                    onClick={e => { handleSerialNumberAdd(e, ni) }}
                                                                                    disabled={product.data.quantity === product.data.serialNumbers.length}
                                                                                >
                                                                                    <i className='fal fa-plus-circle text-success'></i>
                                                                                </button>
                                                                                <button
                                                                                    type='button'
                                                                                    className='btn btn-link btn-icon btn-sm'
                                                                                    onClick={e => { handleSerialNumberRemove(e, ni) }}
                                                                                    disabled={ni === 0 && product.data.serialNumbers.length === 1}
                                                                                >
                                                                                    <i className='fal fa-minus-circle text-danger'></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            </> : null
                                        )}</Observer> */}
                                        <Observer>{() => (
                                            product.isReady && product.data && product.data.type && product.options && product.data.type.data && product.data.type.data.length > 0 ?
                                                <section className='mt-8'>
                                                    <div className='row'>
                                                        <div className='col-12'>
                                                            <label><small>Extra Data</small></label>
                                                            <div className='divider mb-4' />
                                                        </div>
                                                    </div>
                                                    {
                                                        product.data.type.data.map((d, di) => {
                                                            return <div key={`extra_data_${di}`} className='row'>
                                                                <div className='col-12'>
                                                                    <div className='form-group mb-4'>
                                                                        <label htmlFor={d.key}><small>{d.name}</small></label>
                                                                        {
                                                                            product.options.some(o => o.key === d.key) ?
                                                                                <Combobox
                                                                                    className='placeholder placeholder-sm'
                                                                                    data={product.options.filter(o => o.key === d.key)}
                                                                                    dropUp={product.data.type.data.length - di < 4}
                                                                                    filter={(item, value) => {
                                                                                        return item.value.toLowerCase().startsWith(value.toLowerCase());
                                                                                    }}
                                                                                    value={getOptionValue(d.key)}
                                                                                    itemComponent={({ item }) => (
                                                                                        item ? <>{item.value}</> : <></>
                                                                                    )}
                                                                                    valueComponent={({ item }) => (
                                                                                        item ? <>{item.value}</> : <></>
                                                                                    )}
                                                                                    onChange={value => { handleOptionValueChange(d.key, value) }}
                                                                                /> :
                                                                                <input
                                                                                    id={d.key}
                                                                                    type='text'
                                                                                    className='form-control placeholder placeholder-sm'
                                                                                    spellCheck={false}
                                                                                    maxLength='50'
                                                                                    autoComplete='off'
                                                                                    value={getOptionValue(d.key)}
                                                                                    onChange={e => { handleOptionTextChange(e, d.key) }}
                                                                                />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        })
                                                    }
                                                </section> : null
                                        )}</Observer>
                                    </div>
                                </FadeIn> : renderQuickDrawerLoading()
                        }</Observer>
                    </div>
                    <div className='quick-drawer-action'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='float-right'>
                                    <button
                                        type='button'
                                        className='btn btn-link btn-cancel mr-2'
                                        onClick={handleCancel}
                                    >Cancel</button>
                                    <button
                                        type='submit'
                                        className='btn btn-success'
                                    >Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
        <BodyEnd>
            <ConfirmModal
                icon={<i className={oh.getIcon('product', 'type') + ' text-warning mr-2'}></i>}
                message={<>Moving <span className='fw-500 mx-2'>{product.data ? product.data.name : null}</span> to {product.selectedType ? product.selectedType.name : null}?</>}
                show={confirmTypeChange}
                option1ClassName='btn btn-warning shadow-0 bootbox-accept'
                onOption1Click={handleConfirmTypeChange}
                onCancel={handleCancelTypeChange}
            />
            <ConfirmModal
                icon={<i className={oh.getIcon('product', 'brand') + ' text-warning mr-2'}></i>}
                message={<>Add<span className='fw-500 mx-2'>{product.newBrandMapping ? product.newBrandMapping.name : null}</span> brand to {product.selectedType ? product.selectedType.name : null}?</>}
                show={confirmNewBrandMapping}
                option1ClassName='btn btn-warning shadow-0 bootbox-accept'
                onOption1Click={handleConfirmNewBrandMapping}
                onCancel={handleCancelNewBrandMapping}
            />
        </BodyEnd>
    </>
}

export default UpdateProduct;